import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import * as Constants from "./Constants/index";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default function BarChart() {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Quantity",
        data: [],
        backgroundColor: "#90c4e2",
        borderColor: "#90c4e2",
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    const fetchData = async () => {
      let token = localStorage.getItem("token");

      try {
        const response = await axios.post(
          Constants.baseUrl + "capture/qr/product_report_trend",
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language":
                localStorage.getItem("langauge") ||
                localStorage.getItem("language"),
              appVersion: Constants.av,
              platform: Constants.pt,
              program: Constants.program,
              company: Constants.company,
            },
          },
        );

        if (response.status === 201 && response.data.code === 10001) {
          const apiData = response.data.output;

          const labels = apiData.map((item) => item.category || "Unknown");

          const data = apiData.map((item) => item.total_scan);

          // MULTI LINE LABELS
          const formattedNames = labels.map((name) => {
            const parts = String(name).split(" ");

            return [
              parts[0] || "",
              parts[1] || "",
              parts[2] || "",
              parts[3] || "",
            ];
          });

          setChartData({
            labels: formattedNames,
            datasets: [
              {
                label: "Quantity",
                data,
                backgroundColor: "#90c4e2",
                borderColor: "#90c4e2",
                borderWidth: 1,
                borderRadius: 0,
                borderSkipped: false,
                maxBarThickness: 40,
              },
            ],
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "top",

        labels: {
          color: "#6d6d6d",
          boxWidth: 44,
          boxHeight: 12,
          padding: 18,

          font: {
            size: 11,
          },
        },
      },

      title: {
        display: true,
        text: "Product Category Performance",

        color: "#686868",

        padding: {
          top: 10,
          bottom: 12,
        },

        font: {
          size: 11,
          weight: "600",
        },
      },

      tooltip: {
        backgroundColor: "#145f98",
        titleColor: "#ffffff",
        bodyColor: "#ffffff",
        displayColors: false,
      },
    },

    scales: {
      x: {
        grid: {
          color: "rgba(0, 0, 0, 0.08)",
          drawBorder: false,
        },

        border: {
          display: true,
          color: "rgba(0, 0, 0, 0.10)",
        },

        ticks: {
          color: "#666666",

          autoSkip: false,

          font: {
            size: 10,
          },

          callback: function (value) {
            return this.getLabelForValue(value);
          },

          maxRotation: 0,
          minRotation: 0,
        },
      },

      y: {
        beginAtZero: true,

        grid: {
          color: "rgba(0, 0, 0, 0.08)",
          drawBorder: false,
        },

        border: {
          display: false,
        },

        ticks: {
          color: "#666666",

          precision: 0,

          font: {
            size: 10,
          },
        },
      },
    },
  };

  return (
    <div className="dashboard-mock-bar-shell">
      <div className="dashboard-mock-bar-card">
        <div className="dashboard-mock-bar-card-head">
          <h3>Product Category Performance</h3>
        </div>

        {/* SCROLLABLE CHART */}
        <div
          className="dashboard-mock-bar-card-body"
          style={{
            overflowX: "auto",
            overflowY: "hidden",
            width: "100%",
          }}
        >
          {/* DYNAMIC WIDTH */}
          <div
            style={{
              minWidth: `${chartData.labels.length * 80}px`,
              height: "300px",
            }}
          >
            <Bar data={chartData} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
}
